import DashboardLayout from "@/pages/layouts/DashboardLayout";

let newsTypeRoutes = {
  path: '/news-types',
  component: DashboardLayout,
  redirect: '/news-types/list',
  children: [
    {
      path: 'list',
      name: 'News Type List',
      component: () => import(/* webpackChunkName: "newsTypes" */  '@/pages/news/newsTypes/NewsTypeList'),
      meta: {
        permissionsCodes: ['news-types/index'],
      }
    },
    {
      path: 'create',
      name: 'Add News Type',
      component: () => import(/* webpackChunkName: "newsTypes" */  '@/pages/news/newsTypes/NewsTypeForm'),
      meta: {
        permissionsCodes: ['news-types/create'],
      }
    },
    {
      path: 'edit/:id',
      name: 'Edit News Type',
      component: () => import(/* webpackChunkName: "newsTypes" */  '@/pages/news/newsTypes/NewsTypeForm'),
      meta: {
        permissionsCodes: ['news-types/update'],
      }
    }
  ]
}

export default newsTypeRoutes;
